import { ReactNode } from 'react';

export const GuideItem = ({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: ReactNode;
}) => {
  return (
    <div className="flex flex-col gap-3">
      <h6 className="global-t6-semibold">{title}</h6>
      {description ? <p className="body-16-light">{description}</p> : null}
      {children}
    </div>
  );
};
